<template>
    <MainPage :pageTitle="title" bgClass="bg-a-gray-efefef">
        <div class="m-2" v-if="isLoaded">
            <PolicyInfo :policyDetail="policyDetail"></PolicyInfo>
            <TypeRepair :policyDetail="policyDetail"></TypeRepair>
            <ProtectionInfo :policyDetail="policyDetail"></ProtectionInfo>
        </div>
    </MainPage>
</template>

<script>
import MainPage from '@/components/Layout/Page/MainPage.vue';
import PolicyInfo from '@/module/PolicyListing/component/PolicyDetail/PolicyInfo.vue';
import TypeRepair from '@/module/PolicyListing/component/PolicyDetail/TypeRepair.vue';
import ProtectionInfo from '@/module/PolicyListing/component/PolicyDetail/ProtectionInfo.vue';
import Policyservice from '../service/PolicyService.js'
import { useTracking } from "@/feature/TrackingFeature"
import CacheHelper from "@/helper/CacheHelper.js"

export default {
    name: 'PolicyDetail',
    components: {
        MainPage,
        PolicyInfo,
        TypeRepair,
        ProtectionInfo
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            title: 'ความคุ้มครอง',
            policyDetail: null,
            policyId: null,
            isLoaded: false,
        }
    },
    created: function() {
        this.tracking.screenName('policy_detail')
        this.tracking.event("policy_detail_page", "view_policy_detail", "", "");
        if(this.$route.params?.id) {
            this.policyId = this.$route.params.id
            this.cache = new CacheHelper('local')
            this.cache.setCache('policyId', this.policyId)

            window.location.replace(`/policydetail`)
        }
        this.getPolicyDetail()
    },
    methods: {
        getPolicyDetail: function() {
            this.cache = new CacheHelper('local')
            this.policyId = this.cache.getCache('policyId')
            return new Promise((resolve) => {
                Policyservice.apiGetPolicyDetail(this.policyId).subscribe({
                    next: (policy) => {
                        this.policyDetail = policy
                        console.log(this.policyDetail)
                        this.isLoaded = true
                        resolve();
                    },
                    error: (err) => {
                        this.errorApi(err);
                        this.isLoaded = true
                        resolve();
                    },
                });
            });
        },
    },
}
</script>


